import { getBaseUrl } from '../utils/getBaseUrl'; 

const baseURL = getBaseUrl() + 'dashboard/';

export const GetDashboardData = async () => {
    try {
        const response = await fetch(baseURL + 'getcount', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching all dashboard data:', error);
    }
};
